export enum SWState {
    PROCESSING = "PROCESSING",
    STARTING = "STARTING",
    IDLE = "IDLE",
    COMPLETED = "COMPLETED"
}
